import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { mediaUrl } from "@/lib/media";
import { Section } from "@/components/Section";

export default function Blog() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/blogs").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <>
      <section className="bg-[#1A1A1A] text-white py-20 noise-overlay">
        <Section>
          <div className="label-eyebrow mb-4">Blog</div>
          <h1 className="heading-xl text-4xl sm:text-5xl lg:text-6xl">INDUSTRY <span className="text-[#E65C00]">READING</span></h1>
          <p className="mt-4 text-gray-400 max-w-xl">Equipment guides, market trends and finance strategy — written by the people who sell the steel.</p>
        </Section>
      </section>

      <Section className="py-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.length === 0 && <div className="text-center py-20 col-span-full border border-dashed border-gray-300 text-gray-500">No articles yet.</div>}
        {items.map((b) => (
          <Link key={b.id} to={`/blog/${b.slug}`} className="card-industrial block group" data-testid={`blog-grid-${b.id}`}>
            <div className="aspect-[16/10] overflow-hidden bg-gray-100">
              <img src={mediaUrl(b.cover_image)} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-5">
              <div className="label-eyebrow !text-gray-500">{b.category}</div>
              <h3 className="font-heading font-black text-lg mt-2 leading-tight group-hover:text-[#E65C00]">{b.title}</h3>
              <p className="text-sm text-gray-600 mt-2 line-clamp-3">{b.excerpt}</p>
              <div className="text-xs text-gray-400 mt-4 uppercase tracking-widest">{b.author}</div>
            </div>
          </Link>
        ))}
      </Section>
    </>
  );
}
